import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape } from '../../../../helpers/custom-prop-types';
import PlainInput from '../../../Ui/Common/PlainInput';
const ProfessionalUnitCompanyContactAnonymous = (props) => {
    const { input, meta } = props;
    return (_jsx("div", Object.assign({ className: 'field' }, { children: _jsx("div", { children: _jsxs("label", Object.assign({ className: 'pointer anonymous_checkbox' }, { children: [_jsxs("div", Object.assign({ className: 'checkbox_wrapper' }, { children: [_jsx(PlainInput, { checked: input.value, className: '', input: input, meta: meta, type: 'checkbox' }), _jsx("i", {})] })), _jsx("span", { children: "\u533F\u540D\u3067\u554F\u3044\u5408\u308F\u305B\u308B\uFF08\u696D\u754C\u30FB\u58F2\u4E0A\u898F\u6A21\u306E\u307F\u30B3\u30F3\u30B5\u30EB\u3078\u958B\u793A\u3055\u308C\u307E\u3059\uFF09" })] })) }) })));
};
ProfessionalUnitCompanyContactAnonymous.propTypes = {
    input: propShape().isRequired,
    meta: propShape().isRequired,
};
export default ProfessionalUnitCompanyContactAnonymous;
